<template>
  <div class="main">
    <div class="title" />
    <div class="content scrollable">
      <!-- 原有图表模块保持不变 -->
      <el-row>
        <el-col :span="12" class="a">
          <ik-bar-stack-chart
            v-if="index"
            code="1"
            height="300px"
            title="接诊情况"
            :data="doctorweekdiag"
          />
        </el-col>
        <el-col :span="12" class="a">
          <ik-line-time-chart
            v-if="index"
            code="2"
            height="300px"
            title="客流趋势"
            :data="storeweekdiag"
          />
        </el-col>
        <el-col :span="6" class="a">
          <ik-pie-base-chart
            v-if="index"
            code="4"
            height="300px"
            title="库存构成"
            :data="storeinventory"
          />
        </el-col>
        <el-col :span="18" class="a">
          <ik-line-time-chart
            v-if="index"
            code="5"
            height="300px"
            title="销售构成"
            :data="storeweekpay"
          />
        </el-col>
      </el-row>

      <!-- 数据统计与全国热力分析合并为一行 -->
      <el-row class="combined-section">
        <!-- 左侧：数据统计（含年月日切换） -->
        <el-col :span="12">
          <div class="section-header">
            <span class="section-title">运营数据</span>
            <el-radio-group v-model="timeRange" size="small" class="time-switch">
              <el-radio-button label="day">日</el-radio-button>
              <el-radio-button label="week">周</el-radio-button>
              <el-radio-button label="month">月</el-radio-button>
            </el-radio-group>
          </div>
          <div class="table-card unified-table">
            <el-table :data="filteredData" height="400" size="small" border>
              <el-table-column prop="time" :label="timeLabel" width="100" align="center" />
              <el-table-column prop="detectCount" label="检测人数" width="100" align="center" />
              <el-table-column prop="detectCount" label="检测未付费人数" width="100" align="center" />
              <el-table-column prop="detectCount" label="检测已付费人数" width="100" align="center" />
              <el-table-column prop="revenue" label="销售额" align="center">
                <template slot-scope="scope">
                  <span style="color: #409EFF; font-weight: 500;">¥{{ scope.row.revenue }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="revenue" label="收益流水" align="center">
                <template slot-scope="scope">
                  <span style="color: #409EFF; font-weight: 500;">¥{{ scope.row.revenue }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>

        <!-- 右侧：全国热力分析（表格形式） -->
        <el-col :span="12">
          <div class="section-header">
            <span class="section-title">全国热力分析</span>
          </div>
          <div class="table-card unified-table">
            <el-table :data="heatMapData" height="400" size="small" border>
              <el-table-column prop="province" label="省" width="120" align="center" />
              <el-table-column prop="city" label="市" width="120" align="center" />
              <el-table-column prop="detectCount" label="检测人数" width="100" align="center" />
              <el-table-column prop="scanAmount" label="扫码金额" align="center">
                <template slot-scope="scope">
                  <span style="color: #409EFF; font-weight: 500;">¥{{ scope.row.scanAmount }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import IkLineTimeChart from '@/components/ik/echarts/chart/line/base/IkLineBaseChart'
import IkBarStackChart from '@/components/ik/echarts/chart/bar/stack/IkBarStackChart'
import IkPieBaseChart from '@/components/ik/echarts/chart/pie/base/IkPieBaseChart'
import { postData } from '@/api/user/authApi'
import dayjs from 'dayjs'
import * as echarts from 'echarts'

export default {
  components: {
    IkLineTimeChart,
    IkBarStackChart,
    IkPieBaseChart
  },
  data() {
    return {
      doctorweekdiag: [],
      storeweekdiag: [],
      storeinventory: [],
      storeweekpay: [],
      index: false,
      timeRange: 'day', // 切换状态：day/week/month
      // 日数据：2026年4月当月每天
      dailyData: [
        { time: '04-01', detectCount: 120, revenue: '14,700' },
        { time: '04-02', detectCount: 135, revenue: '16,538' },
        { time: '04-03', detectCount: 98, revenue: '12,005' },
        { time: '04-04', detectCount: 142, revenue: '17,395' },
        { time: '04-05', detectCount: 156, revenue: '19,110' },
        { time: '04-06', detectCount: 178, revenue: '21,805' },
        { time: '04-07', detectCount: 165, revenue: '20,213' },
        { time: '04-08', detectCount: 132, revenue: '16,170' },
        { time: '04-09', detectCount: 145, revenue: '17,763' },
        { time: '04-10', detectCount: 128, revenue: '15,680' },
        { time: '04-11', detectCount: 138, revenue: '16,885' },
        { time: '04-12', detectCount: 152, revenue: '18,570' },
        { time: '04-13', detectCount: 143, revenue: '17,489' },
        { time: '04-14', detectCount: 167, revenue: '20,421' },
        { time: '04-15', detectCount: 158, revenue: '19,315' },
        { time: '04-16', detectCount: 149, revenue: '18,228' },
        { time: '04-17', detectCount: 162, revenue: '19,812' },
        { time: '04-18', detectCount: 175, revenue: '21,413' },
        { time: '04-19', detectCount: 181, revenue: '22,143' },
        { time: '04-20', detectCount: 154, revenue: '18,840' },
        { time: '04-21', detectCount: 168, revenue: '20,556' },
        { time: '04-22', detectCount: 172, revenue: '21,044' },
        { time: '04-23', detectCount: 159, revenue: '19,458' },
        { time: '04-24', detectCount: 148, revenue: '18,105' },
        { time: '04-25', detectCount: 163, revenue: '19,947' },
        { time: '04-26', detectCount: 177, revenue: '21,663' },
        { time: '04-27', detectCount: 185, revenue: '22,643' },
        { time: '04-28', detectCount: 171, revenue: '20,928' },
        { time: '04-29', detectCount: 166, revenue: '20,316' },
        { time: '04-30', detectCount: 144, revenue: '17,628' }
      ],
      // 周数据：2026年4月各周统计
      weeklyData: [
        { time: '第1周', detectCount: 892, revenue: '109,270' },
        { time: '第2周', detectCount: 945, revenue: '115,763' },
        { time: '第3周', detectCount: 878, revenue: '107,555' },
        { time: '第4周', detectCount: 1125, revenue: '137,813' }
      ],
      // 月数据：2026年当年各月统计
      monthlyData: [
        { time: '1月', detectCount: 3850, revenue: '471,325' },
        { time: '2月', detectCount: 3420, revenue: '418,650' },
        { time: '3月', detectCount: 4280, revenue: '523,580' },
        { time: '4月', detectCount: 3840, revenue: '470,400' },
        { time: '5月', detectCount: 4100, revenue: '502,250' },
        { time: '6月', detectCount: 3950, revenue: '483,875' },
        { time: '7月', detectCount: 4320, revenue: '529,200' },
        { time: '8月', detectCount: 4180, revenue: '512,050' },
        { time: '9月', detectCount: 4050, revenue: '495,675' },
        { time: '10月', detectCount: 4380, revenue: '536,100' },
        { time: '11月', detectCount: 4220, revenue: '516,550' },
        { time: '12月', detectCount: 4650, revenue: '569,025' }
      ],
      // TOP5城市数据
      top5Cities: [
        { city: '上海市', detectCount: 15800, percentage: 100 },
        { city: '北京市', detectCount: 14250, percentage: 90 },
        { city: '广州市', detectCount: 12680, percentage: 80 },
        { city: '深圳市', detectCount: 11500, percentage: 73 },
        { city: '杭州市', detectCount: 9800, percentage: 62 }
      ],
      chinaMapChart: null,
      inevnType: [
        { key: '1', value: '中成药' },
        { key: '2', value: '西药' },
        { key: '3', value: '饮片' },
        { key: '4', value: '服务' },
        { key: '5', value: '产品' }
      ],
      heatMapData: [
        { province: '北京市', city: '北京市', detectCount: 17272, scanAmount: '2,435,352' },
        { province: '上海市', city: '上海市', detectCount: 16746, scanAmount: '2,143,488' },
        { province: '广东省', city: '广州市', detectCount: 15137, scanAmount: '1,892,125' },
        { province: '广东省', city: '深圳市', detectCount: 12659, scanAmount: '1,822,896' },
        { province: '四川省', city: '成都市', detectCount: 11929, scanAmount: '1,765,492' },
        { province: '湖南省', city: '长沙市', detectCount: 11620, scanAmount: '1,650,040' },
        { province: '重庆市', city: '重庆市', detectCount: 11581, scanAmount: '1,575,016' },
        { province: '陕西省', city: '西安市', detectCount: 10903, scanAmount: '1,613,644' },
        { province: '河南省', city: '郑州市', detectCount: 10747, scanAmount: '1,332,628' },
        { province: '江苏省', city: '苏州市', detectCount: 9921, scanAmount: '1,289,730' },
        { province: '浙江省', city: '杭州市', detectCount: 8430, scanAmount: '1,247,640' },
        { province: '江苏省', city: '南京市', detectCount: 8033, scanAmount: '1,060,356' },
        { province: '湖北省', city: '武汉市', detectCount: 8002, scanAmount: '1,184,296' },
        { province: '江西省', city: '南昌市', detectCount: 7789, scanAmount: '965,836' },
        { province: '天津市', city: '天津市', detectCount: 7616, scanAmount: '1,142,400' },
        { province: '山西省', city: '太原市', detectCount: 7287, scanAmount: '1,085,763' },
        { province: '吉林省', city: '长春市', detectCount: 7040, scanAmount: '971,520' },
        { province: '广东省', city: '佛山市', detectCount: 6729, scanAmount: '820,938' },
        { province: '山东省', city: '济南市', detectCount: 6726, scanAmount: '901,284' },
        { province: '福建省', city: '厦门市', detectCount: 6489, scanAmount: '804,636' },
        { province: '云南省', city: '昆明市', detectCount: 6229, scanAmount: '759,938' },
        { province: '黑龙江省', city: '哈尔滨市', detectCount: 6017, scanAmount: '734,074' },
        { province: '江苏省', city: '无锡市', detectCount: 5778, scanAmount: '820,476' },
        { province: '河北省', city: '石家庄市', detectCount: 5570, scanAmount: '779,800' },
        { province: '山东省', city: '青岛市', detectCount: 4979, scanAmount: '637,312' },
        { province: '辽宁省', city: '沈阳市', detectCount: 4675, scanAmount: '631,125' },
        { province: '贵州省', city: '贵阳市', detectCount: 4538, scanAmount: '680,700' },
        { province: '甘肃省', city: '兰州市', detectCount: 4428, scanAmount: '637,632' },
        { province: '广西壮族自治区', city: '南宁市', detectCount: 4399, scanAmount: '527,880' },
        { province: '安徽省', city: '合肥市', detectCount: 4280, scanAmount: '560,680' },
        { province: '湖南省', city: '株洲市', detectCount: 4142, scanAmount: '571,596' },
        { province: '宁夏回族自治区', city: '银川市', detectCount: 4013, scanAmount: '529,716' },
        { province: '江苏省', city: '徐州市', detectCount: 3655, scanAmount: '471,495' },
        { province: '浙江省', city: '宁波市', detectCount: 3654, scanAmount: '511,560' },
        { province: '四川省', city: '绵阳市', detectCount: 3634, scanAmount: '436,080' },
        { province: '海南省', city: '海口市', detectCount: 3571, scanAmount: '432,091' },
        { province: '新疆维吾尔自治区', city: '乌鲁木齐市', detectCount: 3384, scanAmount: '494,064' },
        { province: '山东省', city: '烟台市', detectCount: 3223, scanAmount: '431,882' },
        { province: '西藏自治区', city: '拉萨市', detectCount: 3016, scanAmount: '395,096' },
        { province: '浙江省', city: '温州市', detectCount: 3016, scanAmount: '443,352' },
        { province: '湖北省', city: '襄阳市', detectCount: 2611, scanAmount: '336,819' },
        { province: '广东省', city: '东莞市', detectCount: 2475, scanAmount: '301,950' },
        { province: '福建省', city: '福州市', detectCount: 2321, scanAmount: '308,693' },
        { province: '青海省', city: '西宁市', detectCount: 2183, scanAmount: '307,803' },
        { province: '内蒙古自治区', city: '呼和浩特市', detectCount: 1605, scanAmount: '211,860' },
        { province: '河南省', city: '洛阳市', detectCount: 1257, scanAmount: '179,751' }
      ]
    }
  },
  computed: {
    // 根据切换状态返回对应数据
    filteredData() {
      switch (this.timeRange) {
        case 'day':
          return this.dailyData
        case 'week':
          return this.weeklyData
        case 'month':
          return this.monthlyData
        default:
          return []
      }
    },
    // 动态表头
    timeLabel() {
      const map = {
        day: '日期',
        week: '周次',
        month: '月份'
      }
      return map[this.timeRange] || '日期'
    }
  },
  mounted() {
    this.getData()
    this.initChinaMap()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.chinaMapChart) {
      this.chinaMapChart.dispose()
    }
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      if (this.chinaMapChart) {
        this.chinaMapChart.resize()
      }
    },
    getData() {
      const param = {
        storeCode: this.$store.state.user.userCode
      }
      postData('clinic/bi/find/doctorweekdiag', param).then(res => {
        this.doctorweekdiag = res.data.map(item => ({
          type: item.storeUserName,
          dep: item.storeUserCode,
          value: item.count
        }))
      })
      postData('clinic/bi/find/storeweekdiag', param).then(res => {
        this.storeweekdiag = res.data.map(item => ({
          type: dayjs().format('YYYY-MM-' + item.diagDate),
          time: dayjs().format('YYYY-MM-' + item.diagDate),
          value: item.count
        }))
      })
      postData('clinic/bi/find/storeinventory', param).then(res => {
        this.storeinventory = res.data.map(item => ({
          type: this.getOption(item.typeSign),
          dep: item.typeSign,
          value: item.paymentAmount
        }))
      })
      postData('clinic/bi/find/storeweekpay', param).then(res => {
        this.storeweekpay = res.data.map(item => ({
          type: dayjs().format('YYYY-MM-' + item.diagDate),
          time: dayjs().format('YYYY-MM-' + item.diagDate),
          value: item.paymentAmount
        }))
      })
      setTimeout(() => {
        this.index = true
      }, 300)
    },
    getOption(value) {
      const item = this.inevnType.find(e => e.key === value)
      return item ? item.value : ''
    },
    // 初始化中国地图
    async initChinaMap() {
      this.$nextTick(async() => {
        const chartDom = this.$refs.chinaMap
        if (!chartDom) return

        this.chinaMapChart = echarts.init(chartDom)

        if (!echarts.getMap('china')) {
          try {
            const response = await fetch('https://geo.datav.aliyun.com/areas_v3/bound/100000_full.json')
            const chinaJson = await response.json()
            echarts.registerMap('china', chinaJson)
          } catch (error) {
            console.error('中国地图数据加载失败:', error)
            return
          }
        }

        const mapData = [
          { name: '北京', value: 14250 },
          { name: '天津', value: 6800 },
          { name: '上海', value: 15800 },
          { name: '重庆', value: 7200 },
          { name: '河北', value: 4500 },
          { name: '河南', value: 5200 },
          { name: '云南', value: 3800 },
          { name: '辽宁', value: 4100 },
          { name: '黑龙江', value: 3200 },
          { name: '湖南', value: 5800 },
          { name: '安徽', value: 4900 },
          { name: '山东', value: 7600 },
          { name: '新疆', value: 2100 },
          { name: '江苏', value: 8900 },
          { name: '浙江', value: 9800 },
          { name: '江西', value: 4200 },
          { name: '湖北', value: 6100 },
          { name: '广西', value: 3500 },
          { name: '甘肃', value: 2800 },
          { name: '山西', value: 3900 },
          { name: '内蒙古', value: 2600 },
          { name: '陕西', value: 4700 },
          { name: '吉林', value: 3100 },
          { name: '福建', value: 5500 },
          { name: '贵州', value: 3300 },
          { name: '广东', value: 12680 },
          { name: '青海', value: 1800 },
          { name: '西藏', value: 1200 },
          { name: '四川', value: 6700 },
          { name: '宁夏', value: 2200 },
          { name: '海南', value: 2900 },
          { name: '台湾', value: 0 },
          { name: '香港', value: 0 },
          { name: '澳门', value: 0 }
        ]

        const option = {
          tooltip: {
            trigger: 'item',
            formatter: '{b}<br/>检测人数: {c}'
          },
          series: [
            {
              name: '检测人数',
              type: 'map',
              map: 'china',
              roam: true,
              zoom: 1.2,
              emphasis: {
                label: { show: true, color: '#fff' },
                itemStyle: { areaColor: '#ffd700' }
              },
              itemStyle: {
                borderColor: '#999',
                borderWidth: 0.5
              },
              data: mapData
            }
          ]
        }

        this.chinaMapChart.setOption(option)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__header {
  padding: 10px 5px;
  border-bottom: 3px solid #F6F7FB;
  height: 45px;
}

::v-deep .el-card__body {
  padding: 0 20px 0;
  height: calc(100% - 45px);
}

::v-deep .ik-chart-card {
  margin: 15px;
  height: calc(100% - 30px);
}

::v-deep .ik-chart-card-title {
  font-size: 16px;
  font-weight: 900;
  color: #409EFF;
}

.main {
  width: 100%;
  height: 100%;
  position: relative;

  .title {
    height: 50px;
    width: 100%;
    position: absolute;
    top: 0;
    line-height: 50px;
    text-align: center;
    z-index: 99;
    background-size: 100% 100%;
    color: white;
    font-weight: 800;
  }

  .content {
    position: absolute;
    width: 100%;
    height: calc(100% - 50px);
    top: 50px;

    .el-row {
      height: 50%;

      .el-col-6 {
        // height: 100%;
      }
    }
  }

  .scrollable {
    overflow-y: auto;
    overflow-x: hidden;
  }

  // 合并区块样式
  .combined-section {
    padding: 15px;
    height: auto !important;
    margin-top: 20px;

    .el-col-12 {
      padding: 0 10px;
    }
  }

  // 统一样式头部
  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px 10px;
    margin-bottom: 10px;
    border-bottom: 2px solid #E4E7ED;

    .section-title {
      font-size: 18px;
      font-weight: 900;
      color: #409EFF;
    }

    .time-switch {
      .el-radio-button__inner {
        padding: 6px 20px;
      }
    }
  }

  // 统一表格样式
  .unified-table {
    background: white;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  }

  // 热力图整合容器
  .heatmap-unified {
    background: white;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    height: 440px;

    .china-map-compact {
      width: 100%;
      height: 400px;
    }

    .top5-wrapper {
      padding-left: 15px;
      border-left: 1px solid #EBEEF5;
      display: flex;
      flex-direction: column;

      .top5-header {
        font-size: 14px;
        font-weight: bold;
        color: #303133;
        padding-bottom: 10px;
        border-bottom: 1px solid #EBEEF5;
        margin-bottom: 10px;
        flex-shrink: 0;
      }

      .top5-list-compact {
        flex: 1;
        overflow-y: auto;

        .top5-item {
          display: flex;
          align-items: center;
          padding: 15px 0;
          border-bottom: 1px solid #f5f5f5;

          &:last-child {
            border-bottom: none;
          }

          .rank {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            font-size: 12px;
            color: white;
            margin-right: 8px;
            flex-shrink: 0;

            &.rank-1 {
              background: linear-gradient(135deg, #FFD700, #FFA500);
              box-shadow: 0 2px 6px rgba(255, 215, 0, 0.4);
            }

            &.rank-2 {
              background: linear-gradient(135deg, #C0C0C0, #A0A0A0);
              box-shadow: 0 2px 6px rgba(192, 192, 192, 0.4);
            }

            &.rank-3 {
              background: linear-gradient(135deg, #CD7F32, #B87333);
              box-shadow: 0 2px 6px rgba(205, 127, 50, 0.4);
            }

            &.rank-4, &.rank-5 {
              background: #909399;
            }
          }

          .city-info {
            flex: 1;
            min-width: 0;

            .city-name {
              font-size: 13px;
              font-weight: bold;
              color: #303133;
              margin-bottom: 3px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .city-count {
              font-size: 11px;
              color: #909399;
            }
          }

          .city-bar {
            width: 50px;
            height: 4px;
            background: #EBEEF5;
            border-radius: 2px;
            overflow: hidden;
            margin-left: 8px;

            .bar-fill {
              height: 100%;
              background: linear-gradient(90deg, #409EFF, #67C23A);
              border-radius: 2px;
              transition: width 0.5s ease;
            }
          }
        }
      }
    }
  }
}

// 自定义滚动条
.scrollable::-webkit-scrollbar {
  width: 8px;
}

.scrollable::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.scrollable::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 4px;
}

.scrollable::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

// TOP5 列表内部滚动条样式
.top5-list-compact::-webkit-scrollbar {
  width: 4px;
}

.top5-list-compact::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 2px;
}
</style>
